module.exports = __webpack_public_path__ + "img/ico-point.e4198d0c.svg";